/**
 * Loading skeleton shared between CompanyGHGPage and GHGOverviewPage.
 * Renders: org-level emission card placeholders + transport-mode chart-pair placeholders.
 * Each page appends its own table skeleton separately (columns differ).
 */

import React from 'react';
import { Box, Grid, Paper, Skeleton } from '@mui/material';

const GhgLoadingSkeleton: React.FC = () => (
  <>
    {/* Organizational-level emission cards */}
    <Box sx={{ mb: 3 }}>
      <Skeleton variant="text" width={280} sx={{ fontSize: '1.25rem', mb: 2 }} />
      <Grid container spacing={2}>
        {Array.from({ length: 5 }, (_, i) => `org-skeleton-${i}`).map((cardKey) => (
          <Grid item xs={12} sm={6} md={2.4} key={cardKey} sx={{ display: 'flex' }}>
            <Paper sx={{ p: 2.5, width: '100%', display: 'flex', flexDirection: 'column', gap: 0.5 }}>
              <Skeleton variant="text" width="80%" sx={{ fontSize: '0.65rem' }} />
              <Skeleton variant="text" width="60%" sx={{ fontSize: '2rem' }} />
              <Skeleton variant="text" width="40%" sx={{ fontSize: '0.75rem' }} />
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>

    {/* Transport-mode chart pair */}
    <Skeleton variant="text" width={260} sx={{ fontSize: '1.25rem', mb: 2 }} />
    <Grid container spacing={3} mb={4}>
      {[0, 1].map((i) => (
        <Grid item xs={12} md={6} key={`chart-skeleton-${i}`}>
          <Paper sx={{ p: 2.5 }}>
            <Skeleton variant="text" width={200} sx={{ fontSize: '1rem', mb: 2 }} />
            <Skeleton variant="rounded" width="100%" height={280} />
          </Paper>
        </Grid>
      ))}
    </Grid>
  </>
);

export default GhgLoadingSkeleton;
